import { Routes } from '@angular/router';
import { LoginComponent } from "./login/login.component";
import { Home } from './home/home';
import { Buyer } from './entities/buyer/buyer-list/buyer.component';
import { UserRouteAccessService } from './login/user-route-access.service';
import { Intern } from './entities/intern/intern-list/intern.component';
import { Orders } from './orders/orders';
import { ROLE_ADMIN, ROLE_BUYER, ROLE_MANAGER, ROLE_OWNER } from './core/config/role.constants';
import { Product } from './entities/product/product-list/product.component';
import { ProductCatalogComponent } from './orders/product-catalog/product-catalog.component';
import { MassiveLoadComponent } from './orders/massive-load/massive-load.component';
import { Item } from './entities/item/item-list/item.component';
import { Color } from './entities/color/color-list/color.component';
import { RelatedItems } from './orders/related-items/related-items';
import { ConfirmOrder } from './orders/confirm-order/confirm-order';
import { UserProfileComponent } from './home/user-profile/user-profile.component';
import { Sales } from './entities/sales/sales';
import { SalesReport } from './entities/sales-report/sales-report';

export const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  {
    path: 'home',
    component: Home,
    canActivate: [UserRouteAccessService],
    children: [
      {
        path: 'perfil',
        component: UserProfileComponent,
        canActivate: [UserRouteAccessService],
        data: { roles: [ROLE_BUYER, ROLE_OWNER], force: false }
      },

      {
        path: 'comprador',
        component: Buyer,
        canActivate: [UserRouteAccessService],
        data: { roles: [ROLE_ADMIN], force: false }
      },
      {
        path: 'interno',
        component: Intern,
        canActivate: [UserRouteAccessService],
        data: { roles: [ROLE_ADMIN], force: false }
      },
      {
        path: 'pedidos',
        component: Orders,
        canActivate: [UserRouteAccessService],
        data: { roles: [ROLE_BUYER, ROLE_OWNER], force: false },
      },
      {
        path: 'pedidos/crear',
        component: ProductCatalogComponent,
        canActivate: [UserRouteAccessService],
        data: { roles: [ROLE_BUYER], force: false },
      },
      {
        path: 'pedidos/complementarios',
        component: RelatedItems,
        canActivate: [UserRouteAccessService],
        data: { roles: [ROLE_BUYER], force: false },
      },
      {
        path: 'pedidos/crear/confirmar-pedido',
        component: ConfirmOrder,
        canActivate: [UserRouteAccessService],
        data: { roles: [ROLE_BUYER], force: false },
      },
      {
        path: 'pedidos/carga-masiva',
        component: MassiveLoadComponent,
        canActivate: [UserRouteAccessService],
        data: { roles: [ROLE_BUYER], force: false }
      },
      {
        path: 'producto',
        component: Product,
        canActivate: [UserRouteAccessService],
        data: { roles: [ROLE_ADMIN, ROLE_MANAGER], force: false }
      },
      {
        path: 'item',
        component: Item,
        canActivate: [UserRouteAccessService],
        data: { roles: [ROLE_ADMIN, ROLE_MANAGER], force: false }
      },
      {
        path: 'color',
        component: Color,
        canActivate: [UserRouteAccessService],
        data: { roles: [ROLE_ADMIN, ROLE_MANAGER], force: false }
      },
      {
        path: 'ventas',
        component: Sales,
        canActivate: [UserRouteAccessService],
        data: { roles: [ROLE_MANAGER], force: false }
      },
      {
        path: 'ventas/reporte',
        component: SalesReport,
        canActivate: [UserRouteAccessService],
        data: { roles: [ROLE_MANAGER], force: false }
      }
    ]
  }
];
